<template>
    <admin-dashboard-layout>
        <div>
            admin.Index
        </div>
    </admin-dashboard-layout>
</template>

<script>

    import AdminDashboardLayout from "../../layouts/AdminDashboardLayout";

    export default {
        name: "Index",
        components: {AdminDashboardLayout},
        data: function () {
            return {}
        },
    }
</script>

<style scoped>

</style>
